import ProductRules from "./ProductRules";
import SpecificationKeys from "../constants/SpecificationKeys";
import { getProductCodeForRules } from "../utils/productCodeUtils";

const DEFAULT_VALUE_KEY_SORTING = ["pv", "sv", "tv"];

class AssetRules {
  asset: $TSFixMe;

  productRules: $TSFixMe;

  constructor(asset: $TSFixMe) {
    this.asset = asset;
    const productCode = getProductCodeForRules(
      asset.productCode,
      asset.extendedOrderCode,
    );

    this.productRules = ProductRules.find(
      asset.manufacturerName,
      productCode,
      asset.productTenantPublic,
    );
  }

  displayValues(multipleValues = true) {
    if (!this.asset.values) {
      return [];
    }

    const valueKeys = this.asset.values
      .map((value: $TSFixMe) => value.key)
      .sort((a: $TSFixMe, b: $TSFixMe) => {
        if (
          DEFAULT_VALUE_KEY_SORTING.indexOf(a) === -1 &&
          DEFAULT_VALUE_KEY_SORTING.indexOf(b) === -1
        )
          return a.localeCompare(b);
        if (DEFAULT_VALUE_KEY_SORTING.indexOf(a) === -1) return 1;
        if (DEFAULT_VALUE_KEY_SORTING.indexOf(b) === -1) return -1;
        return (
          DEFAULT_VALUE_KEY_SORTING.indexOf(a) -
          DEFAULT_VALUE_KEY_SORTING.indexOf(b)
        );
      });

    const productSpecifications = this.asset.product?.specifications;
    const primaryValueKeys =
      productSpecifications &&
      productSpecifications[
        SpecificationKeys.MultipleAssetValues.PRIMARY_VALUE_KEYS
      ]
        ? productSpecifications[
            SpecificationKeys.MultipleAssetValues.PRIMARY_VALUE_KEYS
          ].value.split(",")
        : undefined;

    const displayValueKeys = primaryValueKeys
      ? primaryValueKeys.filter((key: $TSFixMe) => valueKeys.indexOf(key) >= 0)
      : valueKeys;
    const displayValues = displayValueKeys.map((key: $TSFixMe) =>
      this.asset.values.find((value: $TSFixMe) => value.key === key),
    );
    const values = this.productRules.convertDisplayValues(
      this.asset,
      this.asset.instrumentations,
      displayValues,
    );

    if (!multipleValues && values.length > 1) {
      return [values[0]];
    }

    return values;
  }

  get(rule: $TSFixMe, a: $TSFixMe, b: $TSFixMe, c: $TSFixMe) {
    // @ts-expect-error TS(7052) FIXME: Element implicitly has an 'any' type because type ... Remove this comment to see the full error message
    if (this[rule]) {
      // @ts-expect-error TS(7052) FIXME: Element implicitly has an 'any' type because type ... Remove this comment to see the full error message
      return this[rule](a, b, c);
    }
    return this.productRules.get(rule, a, b, c);
  }
}

export default AssetRules;
